import initHeader from './header'
import {beforeReady} from '../lib/addiesaas'

export const init = () => {
  beforeReady(initHeader)
}

export default init
